"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWithinMonths = exports.overlap = exports.activeStatus = exports.ACTIVE_GRACE_PERIOD = exports.FUTURE = exports.ACTIVE = exports.EXPIRED = exports.INVALID = exports.isFutureAt = exports.isExpiredAt = exports.isActiveAt = exports.isGracePeriod = exports.isFuture = exports.isExpired = exports.isActive = exports.isValid = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("./constants");
const format_1 = __importDefault(require("./format"));
const isValid = (period) => {
    const { startDate = null, startTime = null, endDate = null, endTime = null } = period || {};
    return startDate === endDate && startTime && endTime
        ? startTime <= endTime
        : true === (startDate && (!endDate || startDate <= endDate));
};
exports.isValid = isValid;
const isActive = (period) => {
    return (0, exports.isActiveAt)(period, format_1.default.date(Date.now()));
};
exports.isActive = isActive;
const isExpired = (period) => {
    return (0, exports.isExpiredAt)(period, format_1.default.date(Date.now()));
};
exports.isExpired = isExpired;
const isFuture = (period) => {
    return (0, exports.isFutureAt)(period, format_1.default.date(Date.now()));
};
exports.isFuture = isFuture;
const isGracePeriod = (period) => {
    const { startDate } = period;
    const gracePeriodEnd = (0, moment_1.default)(startDate).subtract(constants_1.GRACE_PERIOD, 'days').format('YYYY-MM-DD');
    return (!(0, exports.isActive)(period) &&
        (0, exports.isActiveAt)(Object.assign(Object.assign({}, period), { startDate: startDate ? gracePeriodEnd : startDate }), format_1.default.date(Date.now())));
};
exports.isGracePeriod = isGracePeriod;
// export const isActiveAt: (period: PeriodI, atDate?: string) => boolean = (period, atDate = null) => {
const isActiveAt = (period, atDate) => {
    if (!(0, exports.isValid)(period) || !atDate) {
        return false;
    }
    const { startDate = null, endDate = null } = period || {};
    if (!startDate || startDate > atDate) {
        return false;
    }
    return !endDate || endDate >= atDate;
};
exports.isActiveAt = isActiveAt;
const isExpiredAt = (period, atDate) => {
    if (!(0, exports.isValid)(period) || !atDate) {
        return false;
    }
    const { startDate, endDate } = period;
    return !!atDate && !!startDate && startDate < atDate && !!endDate && endDate < atDate;
};
exports.isExpiredAt = isExpiredAt;
const isFutureAt = (period, atDate) => {
    if (!(0, exports.isValid)(period) || !atDate) {
        return false;
    }
    const { startDate = null } = period || {};
    return !!startDate && !!atDate && startDate > atDate;
};
exports.isFutureAt = isFutureAt;
exports.INVALID = 'INVALID';
exports.EXPIRED = 'EXPIRED';
exports.ACTIVE = 'ACTIVE';
exports.FUTURE = 'FUTURE';
exports.ACTIVE_GRACE_PERIOD = 'ACTIVE (Grace period)';
const activeStatus = (period) => {
    if (!period || !(0, exports.isValid)(period))
        return exports.INVALID;
    if ((0, exports.isExpired)(period))
        return exports.EXPIRED;
    if (period.gracePeriodStartDate && (0, exports.isGracePeriod)(period))
        return exports.ACTIVE_GRACE_PERIOD;
    if ((0, exports.isFuture)(period))
        return exports.FUTURE;
    return exports.ACTIVE;
};
exports.activeStatus = activeStatus;
const overlap = (a, b) => {
    return !!a && !!b && (0, exports.isValid)(a) && (0, exports.isValid)(b) && ((0, exports.isActiveAt)(a, b.startDate) || (0, exports.isActiveAt)(b, a.startDate));
};
exports.overlap = overlap;
const isWithinMonths = (startDate, months) => {
    const date = new Date();
    date.setMonth(date.getMonth() - months);
    return (0, exports.isFutureAt)({ startDate }, format_1.default.date(date));
};
exports.isWithinMonths = isWithinMonths;
